import { Value } from "react-phone-number-input";

import { ChargebeePlanType, IUserState } from "./types";

export const initialState: IUserState = {
  email: "",
  firstName: "",
  lastName: "",
  active: true,
  phoneNumber: {
    phone: "" as Value,
    country: "GB"
  },
  tenancy: {
    id: "",
    organisations: [],
    name: "",
    address: {
      city: "",
      country: "",
      fullAddress: "",
      state: "",
      street: "",
      zipcode: ""
    },
    logoUri: "",
    emailId: "",
    phoneNumber: {
      phone: "" as Value,
      country: "GB"
    },
    chargebeeCustomerId: "",
    chargebeePlanId: "",
    chargebeePlanType: ChargebeePlanType.TRIAL,
    chargebeeSubscriptionExpiry: "",
    chargebeeSubscriptionId: "",
    billing: {
      // orgName: "",
      address: {
        city: "",
        country: "",
        fullAddress: "",
        state: "",
        street: "",
        zipcode: ""
      },
      billingAddressSame: false,
      emailId: "",
      name: "",
      phoneNumber: {
        phone: "" as Value,
        country: "GB"
      }
    },
    epyxAccountNumber: "",
    epyxSchemeReferenceNumber: "",
    enableEpyxIntegration: false,
    chargebeeAddons: []
  },
  currentTenancy: {
    id: "",
    organisations: [],
    name: "",
    address: {
      city: "",
      country: "",
      fullAddress: "",
      state: "",
      street: "",
      zipcode: ""
    },
    logoUri: "",
    emailId: "",
    phoneNumber: {
      phone: "" as Value,
      country: "GB"
    },
    chargebeeCustomerId: "",
    chargebeePlanId: "",
    chargebeePlanType: ChargebeePlanType.TRIAL,
    chargebeeSubscriptionExpiry: "",
    chargebeeSubscriptionId: "",
    billing: {
      // orgName: "",
      address: {
        city: "",
        country: "",
        fullAddress: "",
        state: "",
        street: "",
        zipcode: ""
      },
      billingAddressSame: false,
      emailId: "",
      name: "",
      phoneNumber: {
        phone: "" as Value,
        country: "GB"
      }
    },
    epyxAccountNumber: "",
    epyxSchemeReferenceNumber: "",
    enableEpyxIntegration: false,
    chargebeeAddons: []
  },
  role: "",
  userRole: {
    id: "",
    key: "",
    name: "",
    policies: []
  },
  currentOrganisation: {
    id: "",
    address: {
      city: "",
      country: "",
      fullAddress: "",
      state: "",
      street: "",
      zipcode: ""
    },
    locale: "en-GB",
    branches: [],
    cashEnabled: true,
    cardEnabled: true,
    payOnCollectionEnabled: true,
    requiresCustomerVerification: false,
    offlineBankTransferEnabled: true,
    payByLinkEnabled: true,
    autoChargeEnabled: false,
    emailId: "",
    name: "",
    phoneNumber: {
      phone: "" as Value,
      country: "GB"
    },
    termsAndConditionsUrl: "",
    currency: "GBP",
    stripeAccountId: "",
    taxes: [],
    orgVatNumber: "",
    orgRegNumber: "",
    logoUrl: "",
    sageAccounting: {
      active: false
    },
    allowCarSharing: false,
    disableMapForCarShareVehicles: false,
    inspectionCheckEnabled: false,
    xeroEnabled: false,
    bookingCategories: []
  },
  currentBranch: {
    id: "",
    groupName: "",
    timeZone: "Europe/London",
    locations: [],
    name: "",
    preBookingQuestions: [],
    additionalDriverQuestions: [],
    isAdditionalDriverQuestionsEnabled: false,
    deliveryQuestions: [],
    distanceUnit: "",
    vehiclePreparationTime: 15,
    carShareGracePeriodMins: 15,
    holidays: [],
    taxes: [],
    eventsColor: [],
    autoColorEnabled: false,
  },
  organisation: {
    id: "",
    address: {
      city: "",
      country: "",
      fullAddress: "",
      state: "",
      street: "",
      zipcode: ""
    },
    locale: "en-GB",
    branches: [],
    cashEnabled: true,
    cardEnabled: true,
    payOnCollectionEnabled: true,
    requiresCustomerVerification: false,
    offlineBankTransferEnabled: true,
    payByLinkEnabled: true,
    autoChargeEnabled: false,
    emailId: "",
    name: "",
    phoneNumber: {
      phone: "" as Value,
      country: "GB"
    },
    termsAndConditionsUrl: "",
    currency: "GBP",
    stripeAccountId: "",
    taxes: [],
    orgVatNumber: "",
    orgRegNumber: "",
    logoUrl: "",
    sageAccounting: {
      active: false
    },
    allowCarSharing: false,
    disableMapForCarShareVehicles: false,
    inspectionCheckEnabled: false,
    bookingCategories: []
  },
  branch: {
    id: "",
    groupName: "",
    timeZone: "",
    locations: [],
    name: "",
    preBookingQuestions: [],
    isAdditionalDriverQuestionsEnabled: false,
    additionalDriverQuestions: [],
    deliveryQuestions: [],
    distanceUnit: "",
    vehiclePreparationTime: 15,
    carShareGracePeriodMins: 15,
    holidays: [],
    taxes: [],
    eventsColor: [],
    autoColorEnabled: false,
  },
  partner: {
    id: "",
    isActive: false,
    partnerId: "",
    partnerName: "",
    partnerType: "",
    defleetCentreType: "",
    address: {
      city: "",
      country: "",
      fullAddress: "",
      state: "",
      street: "",
      zipcode: ""
    },
    email: "",
    phoneNumber: {
      country: "",
      phone: "" as Value
    },
    companyRegistrationNo: "",
    partnerContact: {
      email: "",
      firstName: "",
      lastName: "",
      phoneNumber: {
        country: "",
        phone: "" as Value
      }
    },
    documents: [],
    VAT: "",
    timeZone: "",
    registeredAddress: {
      street: "",
      city: "",
      fullAddress: "",
      state: "",
      zipcode: "",
      country: ""
    },
    tradingAddress: {
      street: "",
      city: "",
      fullAddress: "",
      state: "",
      zipcode: "",
      country: ""
    },
    tradingAddressSame: false,
    billingContact: {
      phoneNumber: {
        phone: "" as Value,
        country: ""
      },
      email: ""
    }
  }
};